import { logInternalError } from './errors';

const SESSION_KEY = 'fi_trial_lp_source';
const TRIAL_LP_SOURCE = 'trial-lp';

/**
 * Marks the current tab session as originating from the trial landing page
 * (BE-3839). The LP's device CTAs deep-link into the PDP, so add-to-cart and
 * order events fire off-LP; persisting this marker lets `augmentProperties`
 * attach the source to every subsequent event, so LP -> ATC and LP -> Order
 * can be measured distinctly from the standard PDP.
 */
export function setTrialLandingSource() {
  try {
    sessionStorage.setItem(SESSION_KEY, TRIAL_LP_SOURCE);
  } catch (err) {
    logInternalError(err, { tags: { context: 'setTrialLandingSource' } });
  }
}

/** Returns `'trial-lp'` when the session started on the trial LP, else `undefined`. */
export function getTrialLandingSource(): string | undefined {
  try {
    return sessionStorage.getItem(SESSION_KEY) ?? undefined;
  } catch (err) {
    logInternalError(err, { tags: { context: 'getTrialLandingSource' } });
    return undefined;
  }
}
